<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>我的消息</h4>
        </div>
        <div class="main-bd mg20 blue-link">

            <el-row class="addBtn">
                <el-button :disabled="disableBatchOption" type="primary" size="small" @click="batchSetRead"> 设为已读
                </el-button>
                <el-button :disabled="disableBatchOption" type="danger" size="small" @click="batchDelete"> 删除消息
                </el-button>
            </el-row>

            <el-tabs v-model="activeTabName">
                <el-tab-pane label="未读消息" name="unreads"></el-tab-pane>
                <el-tab-pane label="已读消息" name="hasReads"></el-tab-pane>
                <el-tab-pane label="全部消息" name="all"></el-tab-pane>
            </el-tabs>

            <el-table :data="messages" style="width: 100%" class="tabTopBorder" v-loading="loading"
                      @selection-change="handleSelectionChange" :default-expand-all="false">

                <el-table-column prop="id" type="selection"></el-table-column>
                <el-table-column prop="created_at" label="时间" width="200"></el-table-column>
                <el-table-column prop="state_label" label="状态" width="100"></el-table-column>
                <el-table-column prop="target_type_label" label="类型" width="100"></el-table-column>
                <el-table-column prop="content" label="消息内容">
                    <template slot-scope="scope">
                        <p v-html="scope.row.content"></p>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>

        </div>
    </div>
</template>

<script>
    import MessageService from "~/services/Message";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        name: "index",
        components: {
            Pagination
        },
        data() {
            return {
                // 默认激活的tab
                activeTabName: '',
                messages: [],
                loading: false,
                disableBatchOption: true,
                linkPage: null,
                selection: [],
            };
        },
        created() {
            this.activeTabName = 'unreads';
            this.getListByTab();
        },

        watch: {
            selection: function (value, oldValue) {
                if (value.length > 0) {
                    this.disableBatchOption = false;
                } else {
                    this.disableBatchOption = true;
                }
            },

            activeTabName: function (value, oldValue) {
                // 第一次加载不触发加载，不然会加载两次
                if (oldValue != '') {
                    this.getListByTab();
                }
            }
        },
        methods: {

            getListByTab(params) {
                if (!params) {
                    params = {};
                }
                switch (this.activeTabName) {
                    case 'unreads':
                        //params['mode'] = 3 // 查看自己的
                        this.getUnreads(params);
                        break;
                    case 'hasReads':
                        this.getHasReads(params);
                        break;
                    case 'all':
                        this.getAllMessages(params);
                        break;
                    default:
                        this.$message.error("无效的 tab 项");
                        break;
                }
            },

            getUnreads(params) {
                this.loading = true;
                MessageService.getMyUnreads(params).then(res => {
                    if (res.code == 0) {
                        this.messages = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                })
            },

            getHasReads(params) {
                MessageService.getMyHasReads(params).then(res => {
                    if (res.code == 0) {
                        this.messages = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                })
            },

            getAllMessages(params) {
                MessageService.getAllMessage(params).then(res => {
                    if (res.code == 0) {
                        this.messages = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                })
            },

            //全选，全不选
            handleSelectionChange(messages) {
                this.selection = [];
                messages.forEach(row => {
                    this.selection.push(row.id);
                });
            },

            // 监听分页切换回调
            watchPageChange(pageParams) {
                let params = {};
                params['page'] = pageParams["page"];
                params['perPage'] = pageParams["perPage"];
                this.getListByTab(params);
            },

            batchSetRead() {
                this.$confirm("确定批量设为已读？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {

                    if (this.selection.length > 0) {
                        MessageService.batchSetRead({
                            messages: this.selection
                        }).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "执行成功!",
                                    type: "success",
                                    showClose: true,
                                });
                                this.getListByTab();
                            }
                        })
                    } else {
                        this.$message.error("请先选择要操作的记录");
                        return;
                    }

                }).catch(() => {
                });
            },

            batchDelete() {
                this.$confirm("确定要删除选中的记录？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {

                    if (this.selection.length > 0) {
                        MessageService.batchDelete({
                            messages: this.selection
                        }).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "执行成功!",
                                    type: "success",
                                    showClose: true,
                                });
                                this.getListByTab();
                            }
                        })
                    } else {
                        this.$message.error("请先选择要操作的记录");
                        return;
                    }

                }).catch(() => {
                });
            }

        }
    }
</script>


// WEBPACK FOOTER //
// src/views/message/index.vue